/**
 * @summary **This function will update the toolkit response for parent child relationship**
 * - returns the updated contents**
 * - one level of parent child relationship is supported**
 * @param {Array<object>} contents `required` contents from cms toolkit response
 * @returns {Array<object>} returns the updated contents with nested childs
 */
export const updateToolkitResponseForChildren = (contents) => {
  const updatedContents = []
  const clonedContents = [...contents]
  clonedContents?.forEach((content, index) => {
    const parent = { ...content, children: [] }
    if (content?.field_is_parent) {
      clonedContents[index] = null
      const childrens = _extractChildrensFromToolkitResponse(clonedContents, content?.field_custom_id)
      parent.children = childrens
    }
    updatedContents.push(parent)
  })
  return updatedContents
}

/**
 * @summary **This function will extract the childrens from the contents**
 * - this is private helper function. Not to be called directly.
 * @param {Array<object>} contents `required` contents from cms toolkit response
 * @param {string} parentId `required` parent id to extract childrens
 * @returns {Array<object>} returns the childrens of the parent
 */
const _extractChildrensFromToolkitResponse = (contents, parentId) => {
  const childrens = []
  contents.forEach((content, index) => {
    if (content?.field_custom_id === parentId) {
      let children = []
      contents[index] = null
      childrens.push({ ...content, children })
    }
  })
  return childrens
}
